import { ChevronLeft, ChevronRight } from "lucide-react";

const pageList = (page, pages) => {
  const set = new Set([1, pages, page - 1, page, page + 1].filter((n) => n >= 1 && n <= pages));
  const sorted = [...set].sort((a, b) => a - b);
  return sorted.flatMap((n, i) => (i && n - sorted[i - 1] > 1 ? ["…", n] : [n]));
};

const navBtn = "inline-flex h-11 items-center gap-1.5 rounded-full border border-[#D4AF37]/40 px-4 text-xs font-semibold uppercase tracking-widest text-[#D4AF37] transition-colors hover:bg-[#D4AF37]/10 disabled:pointer-events-none disabled:opacity-30";

export const BlogPager = ({ page, pages, total, onPage }) => {
  if (pages <= 1) return null;
  return (
    <nav className="mt-14 flex flex-col items-center gap-4" aria-label="Blog pages" data-testid="blog-pager">
      <div className="flex flex-wrap items-center justify-center gap-2">
        <button onClick={() => onPage(page - 1)} disabled={page <= 1} className={navBtn} data-testid="blog-prev"><ChevronLeft size={15} /> Prev</button>
        {pageList(page, pages).map((n, i) => (n === "…"
          ? <span key={`gap-${i}`} className="px-1 text-zinc-600">…</span>
          : <button key={n} onClick={() => onPage(n)} aria-current={n === page ? "page" : undefined} data-testid={`blog-page-${n}`}
              className={`hidden h-11 w-11 rounded-full text-sm font-semibold transition-colors sm:inline-block ${n === page ? "bg-[#D4AF37] text-black" : "border border-white/10 text-zinc-300 hover:border-[#D4AF37]/60 hover:text-white"}`}>{n}</button>))}
        <button onClick={() => onPage(page + 1)} disabled={page >= pages} className={navBtn} data-testid="blog-next">Next <ChevronRight size={15} /></button>
      </div>
      <p className="text-xs uppercase tracking-widest text-zinc-500" data-testid="blog-page-info">Page {page} of {pages} · {total} articles</p>
    </nav>
  );
};
